import axios from 'axios'

const WP_API_BASE_URL = process.env.VUE_APP_WPAPI_URL || ''
const WP_API_TIMEOUT = 30000
const WP_API_BASIC_AUTH = {
  username: process.env.VUE_APP_WPAPI_USER || '',
  password: process.env.VUE_APP_WPAPI_PASS || ''
}

const wpJson = axios.create({
  baseURL: `${WP_API_BASE_URL}/dist/`,
  auth: WP_API_BASIC_AUTH,
  timeout: WP_API_TIMEOUT
})

export async function getEventDetailJson(postId: number) {
  const res = await wpJson.get(`event_detail_${postId}.json`)
  return res
}
